// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--W-99R","triangle":"styles-module--triangle--103LL"};